export const PAGESIZE = {
  EMPLOYERS: 10,
}

export const REACT_APP_MAP_KEY_API = process.env.REACT_APP_MAP_KEY_API

export const MAP_LIBRARY: any = ['geometry', 'drawing', 'places']

export const optionsPolygonDefault = {
  fillColor: `#FFC20F`,
  strokeColor: '#a1a5b7',
  fillOpacity: 0.5,
  strokeWeight: 5,
  clickable: true,
  editable: true,
  zIndex: 1,
}

export const polygonOptionsDefault = {
  fillColor: `#FFC20F`,
  fillOpacity: 0.5,
  strokeWeight: 5,
  clickable: true,
  editable: true,
  zIndex: 1,
}

export const POSITION_LABEL_POLYGON_SELECTED = { x: 0, y: 0 }

const subDomain = window.location.host.split(".")[0].includes('www') ? window.location.host.split(".")[1] : window.location.host.split(".")[0];

export const API_URL = `${process.env.REACT_APP_API_URL}/${subDomain}`

export const MAX_SIZE_SERVICE_ICON = 500 * 1024; // 500 KB

export const RouteOptimization = {
  NoRouteOptimization: "NoRouteOptimization",
  WithRouteOptimization: "WithRouteOptimization",
  SelfDrivenTransport: "SelfDrivenTransport",
}

export const TransportType = {
  SelfDriven: "SelfDriven",
  DesignateDriver: "DesignateDriver",
}

export const SlotDisplayType = {
  ExactVisitTime: "ExactVisitTime",
  DeliveryWindow: "DeliveryWindow"
}

/** Numeric values from API routeOptimizationCfg.slotDisplayType */
export const SlotDisplayTypeValue = {
  ExactVisitTime: 1,
  DeliveryWindow: 2,
} as const

export const MODE = {
  CLUSTER : "cluster"
}

export const TYPE_TEXT = {
  TITLE: 0,
  PLACE_HOLDER: 1
}

export const TYPE_FILE = {
  ALL: 0,
  ENGLISH_MEDIA: 1,
  ARABIC_MEDIA: 2
}

export const reRouteDelay = 1 * 60 * 1000;

export const  QUEUE_NAME = {
  UPDATE_STATUS_QUEUE : "trip_queue_"
}

export const  QUEUE_TRIP_ACTION_TYPE = {
  DROPOFF : "DropOff",
  PICKUP: "PickUp",
  AUTOROUTE :"AutoRoute"
}

export const  CATEGORY_TYPE = {
  B8AK : "B8AK",
  CUSTOM: "EXTERNAL",
}